export enum ClientActions {
  Toggled = 'toggled',
  PageChange = 'pageChange',
  Edit = 'edit',
  Create = 'create',
}